/**
 * NKBA API
 * The RESTful backend behind the NKBA application
 *
 * OpenAPI spec version: V1.0.0
 * Contact: cloud@nkba.org
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { AxiosRequestConfig } from 'axios';
import { axios } from '../axios.config';
import { ChapterPosition } from '../models/ChapterPosition';
import { ResultsPartialMemberObjectId } from '../models/ResultsPartialMemberObjectId';

/* tslint:disable:no-unused-variable member-ordering max-line-length */

export class ChapterPositionApiResource {



    /**
     * Return list of years/positions of all officers by chapter
     * 
     * @param chapterId Chapter id
     */
    public getChapterYearsPositions(chapterId: Partial<string>, info: Partial<string>, axiosConfig?: AxiosRequestConfig): Promise<any> {
        const reqPath = ('/v1/chapter-position/chapter/{chapterId}/' + info)
            .replace('{' + 'chapterId}', String(chapterId));
        let reqConfig = {
            ...axiosConfig,
            method: 'GET',
            url: reqPath
        };
        return axios.request(reqConfig)
            .then(res => {
                return res.data;
            });
    }

    /**
     * Search Members by position
     * 
     * @param body Chapterposition data to search
     */
    public getChapterMembers(body?: Partial<ChapterPosition>, axiosConfig?: AxiosRequestConfig): Promise<ResultsPartialMemberObjectId> {
        const reqPath = 'v1/chapter-position/searchMembers';
        let reqConfig = {
            ...axiosConfig,
            method: 'POST',
            url: reqPath,
            data: body
        };
        return axios.request(reqConfig)
            .then(res => {
                return res.data;
            });
    }

    public getChapterPositions(body?: Partial<any>, axiosConfig?: AxiosRequestConfig): Promise<any> {
        const reqPath = 'v1/chapter-position/search';
        let reqConfig = {
            ...axiosConfig,
            method: 'POST',
            url: reqPath,
            data: body
        };
        return axios.request(reqConfig)
            .then(res => {
                return res.data;
            });
    }

}

export const ChapterPositionApi = new ChapterPositionApiResource();



// WEBPACK FOOTER //
// ./src/common/api/resources/ChapterPositionApi.ts